/* eslint-disable */
module.exports = () => {
  document.querySelector("body").addEventListener("mousedown", function (event) {
    (function () {
      if (typeof (pendo) === 'undefined') {
        return;
      }
      try {
        if (pendo.findGuideById(pendo.findGuideByName("Resource Center").id).isShown() === true) {
          if (!pendo.dom(event.target).closest("#pendo-resource-center-container").length && event.target.alt !== "Help") {
            pendo.BuildingBlocks.BuildingBlockResourceCenter.dismissResourceCenter();
          }
        }
      }
      catch (err) {
      }
    })
      (window, document, 'script', 'pendo');
  })
};